export const ROUTES = [
  { name: "Features", to: "#features" },
  { name: "Pricing", to: "#pricing" },
  { name: "Our Team", to: "#our-team" },
];
